import { JxsComponent } from '@jxs/component';

class JxsHeaderNavigationInfobar extends JxsComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.getDataset('showWithHeader') && !Shopify.designMode) {
      if (!this.closest('sticky-header')) {
        const header = document.querySelector('sticky-header');
        if (header) {
          header.querySelector('jxs-header-navigation-infobar')?.remove();
          header.prepend(this);
          const headerHeight = header.parentElement.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }
}
customElements.define('jxs-header-navigation-infobar', JxsHeaderNavigationInfobar);


class JxsHeaderNavigationStore extends JxsComponent {

  static EU_COUNTRY = 'BE,BG,CZ,DK,DE,EE,IE,GR,ES,FR,HR,IT,CY,LV,LT,LU,HU,MT,NL,AT,PL,PT,RO,SI,SK,FI,SE'.split(',');
  static STORAGE_KEY = 'jxs-store-change-preference';
  static EXPIRY_SEC = 60 * 60 * 24 * 5;
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.getDataset('detectCountry') && this.#shouldShowModal()) {
      customElements.whenDefined('jxs-modal').then(() => {
        const country = this.getDataset('userCountry')
        let storeName = ''
        let storeUrl = ''
        if (country == 'UK') {
          storeName = this.refs.storeUK.querySelector('span').textContent;
          storeUrl = this.refs.storeUK.getAttribute('href');
        } else if (JxsHeaderNavigationStore.EU_COUNTRY.includes(country)) {
          storeName = this.refs.storeEU.querySelector('span').textContent;
          storeUrl = this.refs.storeEU.getAttribute('href');
        }
        if (storeName) {
          this.querySelector('strong[store-name]').textContent = storeName;
          this.querySelector('a[go-store]').setAttribute('href', storeUrl);
          this.querySelector('button[cancel-store]').addEventListener('click', this.#handleCloseStoreChangeModal);
          this.refs.modal.openModal();
        }
      });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.getDataset('detectCountry')) {
      this.querySelector('button[cancel-store]').removeEventListener('click', this.#handleCloseStoreChangeModal);
    }
  }

  #handleCloseStoreChangeModal = () => {
    this.#setSkipAutoRedirect();
    this.refs.modal.closeModal();
  }

  #setSkipAutoRedirect() {
    try {
      const data = {
        skipAutoRedirect: true,
        expiry: Date.now() + (JxsHeaderNavigationStore.EXPIRY_SEC * 1000),
        timestamp: new Date().toISOString()
      };
      localStorage.setItem(JxsHeaderNavigationStore.STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Failed to save store change preference:', error);
    }
  }

  #shouldShowModal() {
    try {
      const preference = localStorage.getItem(JxsHeaderNavigationStore.STORAGE_KEY);
      if (!preference) return true;
      
      const data = JSON.parse(preference);
      const expiryTime = data.expiry;
      const now = Date.now();
      
      if (now > expiryTime) {
        localStorage.removeItem(JxsHeaderNavigationStore.STORAGE_KEY);
        return true;
      }
      
      return !data.skipAutoRedirect;
    } catch (error) {
      console.error('Failed to read store change preference:', error);
      return true;
    }
  }
}
customElements.define('jxs-header-navigation-store', JxsHeaderNavigationStore);